import { MIXPANEL_EVENT_PROPERTIES } from '../../constants';
import { SimpleStore } from '../simple';

export const createSellerIdStore = () =>
    new SimpleStore<typeof MIXPANEL_EVENT_PROPERTIES.SELLER_ID, number>(MIXPANEL_EVENT_PROPERTIES.SELLER_ID);
